import HTMLReactParser from "html-react-parser"
import { Cover } from "@components/anti/Cover"
import { useScrollAnim } from "src/hooks/hooks"
import { imgUrl } from "src/mixins"

function HomeCareer({ data, locale }) {
  const [trigger, anim, inView] = useScrollAnim()
  return (
    <section className="sc-home-career" ref={trigger}>
      <Cover
        img={imgUrl(data?.banner_image_mobile)}
        imgMd={imgUrl(data?.banner_image_desktop)}
        imgHeight="h-500px"
        title={data && data[`title_${locale}`]}
        titleClassName={anim(1)}
        text={data && data[`description_${locale}`]}
        textClassName={anim(3)}
        // imgOverlay={20}
        buttons={[
          {
            text: data[`link_label_${locale}`],
            link: { url: data?.link_url },
            variant: "primary-light",
          },
        ]}
        useNextImage
      />
    </section>
  )
}

export default HomeCareer
